var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 47,
    viewBox: "0 0 67 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 46,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1844 31.0557H17.1255L14.0818 19.1767C13.9373 18.6303 13.6306 18.1472 13.1794 17.9195C12.0533 17.3474 10.8125 16.892 9.45886 16.6623V16.205H15.9974C16.8999 16.205 17.5767 16.892 17.6895 17.6899L19.2687 26.2586L23.3256 16.205H27.2717L21.1844 31.0557ZM29.5278 31.0557H25.6945L28.851 16.205H32.6843L29.5278 31.0557ZM37.6436 20.3191C37.7564 19.5192 38.4332 19.0619 39.2228 19.0619C40.4637 18.9471 41.8153 19.1767 42.9433 19.7469L43.6201 16.5495C42.4921 16.0921 41.2513 15.8625 40.1252 15.8625C36.4048 15.8625 33.6975 17.9195 33.6975 20.7745C33.6975 22.9463 35.6151 24.0867 36.9688 24.7737C38.4332 25.4587 38.9972 25.9161 38.8844 26.6011C38.8844 27.6286 37.7564 28.086 36.6304 28.086C35.2767 28.086 33.9231 27.7435 32.6843 27.1713L32.0074 30.3707C33.3611 30.9409 34.8255 31.1706 36.1791 31.1706C40.3509 31.2834 42.9433 29.2283 42.9433 26.1438C42.9433 22.2593 37.6436 22.0316 37.6436 20.3191ZM56.3589 31.0557L53.3152 16.205H50.0459C49.3691 16.205 48.6923 16.6623 48.4667 17.3474L42.8305 31.0557H46.7766L47.5642 28.8858H52.4128L52.864 31.0557H56.3589ZM50.6099 20.2043L51.736 25.8013H48.5795L50.6099 20.2043Z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 46,
    rx: 3.5,
    stroke: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.1f5264769316a727d444564a8fe9d7f1.svg";
export { ForwardRef as ReactComponent };